import { Star } from 'lucide-react';
import { Progress } from './ui/progress';

export default function ReviewStats({ stats }) {
    if (!stats || stats.total_reviews === 0) {
        return null;
    }

    const { average_rating, total_reviews, rating_distribution } = stats;

    // Calculate percentage for each rating
    const getRatingPercentage = (rating) => {
        if (!rating_distribution) return 0;
        const count = rating_distribution[rating] || 0;
        return total_reviews > 0 ? (count / total_reviews) * 100 : 0;
    };

    return (
        <div className="bg-white rounded-lg border p-6 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Average Rating */}
                <div className="flex flex-col items-center justify-center border-r">
                    <div className="text-5xl font-bold text-gray-900 mb-2">
                        {average_rating.toFixed(1)}
                    </div>
                    <div className="flex items-center gap-1 mb-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <Star
                                key={star}
                                className={`h-6 w-6 ${star <= Math.round(average_rating)
                                    ? 'fill-yellow-400 text-yellow-400'
                                    : 'text-gray-300'
                                    }`}
                            />
                        ))}
                    </div>
                    <p className="text-sm text-gray-600">
                        Basé sur {total_reviews} avis
                    </p>
                </div>

                {/* Rating Distribution */}
                <div className="space-y-2">
                    {[5, 4, 3, 2, 1].map((rating) => (
                        <div key={rating} className="flex items-center gap-3">
                            <div className="flex items-center gap-1 w-16">
                                <span className="text-sm font-medium text-gray-700">{rating}</span>
                                <Star className="h-3 w-3 fill-yellow-400 text-yellow-400" />
                            </div>
                            <Progress
                                value={getRatingPercentage(rating)}
                                className="flex-1 h-2"
                            />
                            <span className="text-sm text-gray-600 w-12 text-right">
                                {(rating_distribution && rating_distribution[rating]) || 0}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
